import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom'
import N3rveLogo from './../../../images/N3rveLogo.png'
import './MFALogin.css'
import Cookies from 'universal-cookie';
import httpConfig from '../../PostLogin/Dashboard/AxiosConfig/httpConfig';
import { login } from '../../PostLogin/Dashboard/AxiosConfig/AxiosInstance';
import axios from 'axios';
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next";
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import GreenTick from './../../../images/greentick.png'
import { useJwt, decodeToken } from "react-jwt";
import { createClient, OAuthStrategy } from '@wix/sdk';
import { items } from "@wix/data";
import { logtoWix } from '../../Helpers/LogToWix';


function MFALogin() {
  const { state } = useLocation();
  const [email, onChangeEmail] = useState(state.email)
  const [password, onChangePassword] = useState('');
  const [passworderror, setPasswordError] = useState(false)
  const [emailerror, setEmailError] = useState(false)
  const [isChecked1, setIsChecked1] = useState(false);
  const [recoveryKey, setRecoveryKey] = useState('');
  const cookies = new Cookies(null, { path: '/' });
  const { t, i18n } = useTranslation();
  const [code, setCode] = useState('');
  const navigate = useNavigate();
  const [toggleRecoveryKey, setToggleRecoveryKey] = useState(false)
  const [accessCodeError, setAccessCodeError] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);
  const [buttonClick, setButtonClick] = useState(0);


  useEffect(() => {
    // exit early when we reach 0
    if (!timeLeft) return;

    if (timeLeft === 1) {
      console.log("TIME LEFT IS 1");
      setButtonClick(0)
    }

    if (timeLeft === 0) {
      console.log("TIME LEFT IS 0");
    }

    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const resetCode = () => {
    inputRefs.forEach(ref => {
      ref.current.value = '';
    });
    inputRefs[0].current.focus();
    setCode('');
  }

  useEffect(() => {
    if (code.length === 6) {
      handleConfirmMfa(code)

    }
  }, [code])


  // Handle input
  function handleInput(e, index) {
    const input = e.target;
    const previousInput = inputRefs[index - 1];
    const nextInput = inputRefs[index + 1];

    // Update code state with single digit
    const newCode = [...code];
    // Convert lowercase letters to uppercase
    if (/^[a-z]+$/.test(input.value)) {
      const uc = input.value.toUpperCase();
      newCode[index] = uc;
      inputRefs[index].current.value = uc;
    } else {
      newCode[index] = input.value;
    }
    setCode(newCode.join(''));

    input.select();

    if (input.value === '') {
      // If the value is deleted, select previous input, if exists
      if (previousInput) {
        previousInput.current.focus();
      }
    } else if (nextInput) {
      // Select next input on entry, if exists
      nextInput.current.select();
    }
  }


  // Select the contents on focus
  function handleFocus(e) {
    e.target.select();
  }

  // Handle backspace key
  function handleKeyDown(e, index) {
    const input = e.target;
    const previousInput = inputRefs[index - 1];
    const nextInput = inputRefs[index + 1];

    if ((e.keyCode === 8 || e.keyCode === 46) && input.value === '') {
      e.preventDefault();
      setCode((prevCode) => prevCode.slice(0, index) + prevCode.slice(index + 1));
      if (previousInput) {
        previousInput.current.focus();
      }
    }
  }

  // Capture pasted characters
  const handlePaste = (e) => {
    const pastedCode = e.clipboardData.getData('text');
    if (pastedCode.length === 6) {
      setCode(pastedCode);
      inputRefs.forEach((inputRef, index) => {
        inputRef.current.value = pastedCode.charAt(index);
      });
    }
  };



  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  })

  const handleResize = () => {
    // console.log(window.innerWidth)
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  const openInNewTab = () => {
    const fromAccountPage = false;
    const fromLogin = true;


    // Store the state in localStorage or sessionStorage
    localStorage.setItem('dashboardProps', JSON.stringify({ fromAccountPage, fromLogin }));

    // Open /Dashboard in a new tab
    window.open("/Dashboard", "_blank");
  };


  const openLabelInNewTab = () => {
    const fromAccountPage = false;
    const fromLogin = true;


    // Store the state in localStorage or sessionStorage
    localStorage.setItem('dashboardProps', JSON.stringify({ fromAccountPage, fromLogin }));

    // Open /Dashboard in a new tab
    window.open("/dashboard/label", "_blank");
  };


  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, [])

  const handleConfirmMfa = (code) => {
    console.log(code)
    console.log(email)
    const current = new Date();
    const nextYear = new Date();
    nextYear.setFullYear(current.getFullYear() + 1)

    axios({
      method: 'post',
      url: "https://n3rve.fly.dev/auth/mfa/login",
      data: {
        code: code.toString(),
        email: email.toString()
      }
    }).then(res => {
      setAccessCodeError(false)
      if (cookies.get("staysignedin")) {
        cookies.set('token', res.data.token, {
          path: '/',
          expires: nextYear
        });
      } else {
        cookies.set('token', res.data.token);
      }
      // navigate("/Dashboard", { state: { fromAccountPage: false,fromLogin:true}})
      navigate("/")
      console.log(res)
      console.log(decodeToken(res.data.token).info.role)
      console.log(typeof (decodeToken(res.data.token).info.role))

      logtoWix(email, "auth", "MFA Page", { "desc": "Successful MFA" })

      if (decodeToken(res.data.token).info.role === "artist" || decodeToken(res.data.token).info.role === "producer") {
        openInNewTab()
      }

      if (decodeToken(res.data.token).info.role === "label") {
        openLabelInNewTab()
      }



    }).catch((e) => {
      console.log(e)
      setAccessCodeError(true)
      logtoWix(email, "auth", "MFA Page", { "desc": "Unsuccessful MFA" })
    })
  }
  const handleSubmit = () => {
    axios({
      method: 'post',
      url: "https://n3rve.fly.dev/auth/mfa/recovery",
      data: {
        recoveryCode: recoveryKey,
        email: email,
        purpose: "login"
      }
    }).then(res => {
      console.log(res)
      const current = new Date();
      const nextYear = new Date();
      nextYear.setFullYear(current.getFullYear() + 1)
      if (cookies.get("staysignedin")) {
        cookies.set('token', res.data.token, {
          path: '/',
          expires: nextYear
        });
      } else {
        cookies.set('token', res.data.token);
      }
      //  navigate("/Dashboard", { state: { fromAccountPage: false, fromLogin:true}})
      navigate("/")

      openInNewTab()

    }).catch((e) => {
      console.log(e)
    })
  }

  const handleToggleMfa = () => {
    axios({
      method: 'post',
      url: "https://n3rve.fly.dev/auth/mfa/toggle",
      headers: {
        Authorization: "Bearer ".concat(cookies.get("token"))
      }
    }).then(res => {
      console.log(res)
    })
  }


  return (
    <div style={{ width: '100vw' }}>



      <div className="LoginContainer">

        <div className='LoginContainerLeft' >
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo' />
          </Link>

          {
            !toggleRecoveryKey &&
            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '11.25em' }}>
              <div className='WelcomeBackTxt'>Enter the Access Code</div>
              <div className='PleaseEnterTxt' style={{ width: '70%' }}>We've sent a one-time access code (6-digits) to your phone. Enter the code below to verify your phone number. This code will expire in 10 minutes.</div>


              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1em', marginLeft: '4em' }}>
                {[0, 1, 2, 3, 4, 5].map((index) => (
                  <input
                    className={!accessCodeError ? 'AccessCodeInput' : 'AccessCodeInputErr'}
                    key={index}
                    type="text"
                    maxLength={1}
                    onChange={(e) => handleInput(e, index)}
                    ref={inputRefs[index]}
                    autoFocus={index === 0}
                    onFocus={handleFocus}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onPaste={handlePaste}
                  />
                ))}
              </div>


              {
                accessCodeError &&
                <div className="AccessCodeError" style={{ marginLeft: '6em' }}>Invalid Code. Please re-enter or request a new one.</div>
              }

              {
                buttonClick === 0 &&
                <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '6em' }}>
                  <div className='DidntReceiveCodeTxt'>
                    Didn't receive the code?
                  </div>
                  <div className='ResendCodeTxt' onClick={() => { handleToggleMfa(); setTimeLeft(30); setButtonClick(1) }}>
                    Resend code
                  </div>
                </div>
              }

              {
                buttonClick === 1 &&
                <div>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <img src={GreenTick} />
                    <div className="NewCodeMsg">A new code was sent</div>
                  </div>
                  <span className="NoPasswordTxt">
                    You can resend in {timeLeft} sec...
                  </span>
                </div>
              }




              <div className='ResendCodeTxt' style={{ marginTop: '2em', marginLeft: '10em', cursor: 'pointer' }} onClick={() => setToggleRecoveryKey(true)}>
                Use Recovery Key
              </div>

            </div>
          }

          {
            toggleRecoveryKey &&
            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '11.25em' }}>
              <div className='WelcomeBackTxt'>Enter Your Recovery Key</div>
              <div className='PleaseEnterTxt' style={{ width: '70%' }}>Can't access your MFA code? Enter the 12-digit recovery key provided to you during the MFA set up process.</div>



              <div className='LoginHeader'>Recovery Key (12-digit)</div>

              <input
                value={recoveryKey}
                onChange={e => setRecoveryKey(e.target.value)}
                placeholder='000 000 000 000'
                className='LoginInput'
                type='text'
              />



              <div onClick={() => handleSubmit()} className='LoginBtn' style={{ textDecoration: 'none', cursor: 'pointer', maxWidth: '70%' }}>{t('Loginbtn')}</div>

            </div>
          }


        </div>

        <div className='LoginContainerRight' style={{ backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/kaktv6iamo5qniikeclw")`, height: dimensions.height, width: '50%' }} />

      </div>



    </div>
  );
}

export default MFALogin;
